<template>
	<div v-loading="loadingDM">
		<el-form
			ref="editorForm"
			:model="info"
			status-icon
			label-position="left"
			label-width="80px"
			size="mini"
			v-loading="loadings.main"
			v-if="hasGetTableDataModel"
			@submit.native.prevent
			:rules="rules"
		>
			<div class="row row-eq-height">
				<div :class="key.col?'col-md-'+key.col:'col-md-3'" v-for="(key,index) in fields" :key="index">
					<el-form-item :label="dataModels[dataModelName][key.name].show_name" :prop="key.name">
						<field-show
							:record-model="dataModelName"
							:field-info="dataModels[dataModelName][key.name]"
							:value="info[key.name]"
							:field-key="key"
							v-if="key.isOnlyShow"
						></field-show>
						<field-editor
							:width="key.width"
							:tips="key.tips"
							v-model="info[key.name]"
							@change="handleFormEdited"
							:field-info="dataModels[dataModelName][key.name]"
							:record-id="recordId"
							:record-model="dataModelName"
							:params="key.params"
							v-else
						></field-editor>
					</el-form-item>
				</div>
			</div>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">确 定</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import FieldEditor from "@/components/FieldEditor.vue";
import FieldShow from "@/components/FieldShow.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import LoadDM from "@/mixins/LoadDM.js";

export default {
	mixins: [LoadDM],
	data() {
		return {
			loadings: {
				formLoading: false,
				main: false
			},
			info: {},
			styles: [],
			visible: false,
			everEdited: false
		};
	},
	props: {
		dataModelName: {
			type: String,
			default: ""
		},
		recordId: {
			type: String,
			default: ""
		},
		show: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			default: "name"
		},
		fields: {
			type: Array,
			default: function() {
				return [];
			}
		},
		rules: {
			type: Object,
			default: function() {
				return {};
			}
		},
		value: {
			type: Object,
			default:  function() {
				return {};
			}
		},
		handlerCtrller: {
			type: String,
			default: "curd"
		}
	},
	mounted() {},
	methods: {
		handleFormEdited() {
			this.everEdited = true;
		},
		handleSelect() {},
		onSubmit() {
			this.$refs["editorForm"].validate(valid => {
				if (!valid) {
					return false;
				}
				this.$emit("submit", JSON.parse(JSON.stringify(this.info)));
			});
		}
	},
	components: {
		FieldEditor,
		FieldShow
	},
	watch: {
		hasGetTableDataModel: {
			handler(val) {
				if (val) {
					this.initInfo();
				}
			},
			immediate: true
		}
	}
};
</script>